import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@shadcn/ui/card";
import { createFileRoute } from "@tanstack/react-router";
import Logo from "@/src/presentation/components/logo";
import ViewmodelWrapper from "@/src/presentation/components/viewmodel-wrapper";
import { ForgotPasswordViewModel } from "@/src/presentation/view-models/forgot-password-viewmodel";
import BackToLoginButton from "./_components/back-to-login-button";
import MainForm from "./_components/main-form";

export const Route = createFileRoute("/_public/forgot-password/")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  return (
    <ViewmodelWrapper type={ForgotPasswordViewModel}>
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
        <div className="w-full max-w-md">
          <Logo />
          <Card className="border-brand-accent-subtle shadow-lg">
            <CardHeader className="space-y-1">
              <CardTitle className="text-2xl font-bold text-center">Forgot Password</CardTitle>
              <CardDescription className="text-center">
                Enter your email address to receive a password reset link
              </CardDescription>
            </CardHeader>
            <CardContent>
              <MainForm />
            </CardContent>
            <CardFooter className="flex flex-col gap-y-4">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <span className="w-full border-t" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-card px-2 text-muted-foreground">Or</span>
                </div>
              </div>
              <BackToLoginButton />
            </CardFooter>
          </Card>
        </div>
      </div>
    </ViewmodelWrapper>
  );
}
